import * as React from "react";
import CCModal from "./CCModal.tsx";
import "../../sass/_dashboard.scss";
import { useState, useContext } from "react";
import LandingPageOptions from "../../assets/landingPageOptions.json";
import { Form } from "react-bootstrap";
import { AuthContext } from "../../auth/AuthRoute";
import "../../sass/_changeLandingPage.scss";
import { HttpContext } from "../../api-services/HttpService";
import PageContext from "./../sub-components/PageContext";

type Props = {
  title?: string;
  show?: boolean;
  primaryButtonName: string;
  secondaryButtonName: string;
  onModalClose: () => void;
};

const ChangeLandingLayout = ({
  title,
  show,
  primaryButtonName,
  secondaryButtonName,
  onModalClose,
}: Props) => {
  const { getLandingPage } = useContext(AuthContext);
  const { POST } = useContext(HttpContext);
  // initialize state for snackbar
  const {
    snackbarAlert,
  } = useContext(PageContext);
  const [currentLandingPage, setCurrentLandingPage] = useState(getLandingPage);
  const [disablePrimaryButton, setDisablePrimaryButton] = useState(true);
  const [landingPage, setLandingPage] = useState(currentLandingPage);

  const checkForChanges = (event) => {
    setLandingPage(event.target.value);
    if (event.target.value !== currentLandingPage) {
      setDisablePrimaryButton(false);
    }
    if (event.target.value === currentLandingPage) {
      setDisablePrimaryButton(true);
    }
  };

  const updateLandingPage = () => {
    return new Promise((resolve, reject) => {
      let response;
      POST("/links/landingPage", {
        route: landingPage,
      })
        .then((res) => {
          // make edit row false
          setCurrentLandingPage(landingPage);
          // show success on snackbar
          snackbarAlert(true, "Successfully updated landing page.", "success");
          // refresh table
          onModalClose();
        })
        .then((res) => {
          console.log(res);
          // resolve on success
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          // show error on snackbar
          snackbarAlert(true, "Error updating landing page.", "error");
          // reject on error
          reject(err);
        });
    });
  };

  return (
    <CCModal
      title={title}
      show={show}
      onModalClose={onModalClose}
      primaryButtonName={primaryButtonName}
      secondaryButtonName={secondaryButtonName}
      primaryAction={updateLandingPage}
      disablePrimaryButton={disablePrimaryButton}
    >
      <div className="landing-page-selection-options">
        <div className="landing-page-selection-list">
          <div
            style={{ borderBottom: "1px solid #e6edf1", paddingBottom: "8px" }}
          >
            {LandingPageOptions.data
              .filter((option) => option.type === "basicOptions")
              .map((dataset) => {
                return (
                  <div className="dataset-radio-options" key={dataset.id}>
                    <Form.Check
                      inline
                      name="landingPageOption"
                      type="radio"
                      label={dataset.name}
                      id={dataset.id}
                      checked={landingPage === dataset.link}
                      onChange={checkForChanges}
                      value={dataset.link}
                    />
                  </div>
                );
              })}
          </div>
          <div className="mt-3">
            <div className="mb-2 dataset-radio-option-name">
              Portfolio Management Dashboards
            </div>
            {LandingPageOptions.data
              .filter((option) => option.type === "portfolioManagementOptions")
              .map((dataset) => {
                return (
                  <div className="dataset-radio-options" key={dataset.id}>
                    <Form.Check
                      inline
                      name="landingPageOption"
                      type="radio"
                      id={dataset.id}
                      label={dataset.name}
                      checked={landingPage === dataset.link}
                      onChange={checkForChanges}
                      value={dataset.link}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </CCModal>
  );
};

export default ChangeLandingLayout;
